export default "__VITE_ASSET__DDERwbJJ__"